import {getAbsoluteUrl} from "../../utils/urlUtill";
import {IDeferred, IHttpPromise, IHttpService, IQService} from "angular";
import {
    CalculationNotificationQuickPriceResult,
    Opportunity,
    OpportunityEventType
} from "../../opportunities/model/Opportunity";
import {Page} from "../../utils/models/Page";
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {OpportunityFilterUi} from "../../opportunities_filter/model/OpportunityFilterUi";


export class CalculationsNotificationService {

    static instance = ['$http', '$q', CalculationsNotificationService];
    private notificationsNumberSubject = new BehaviorSubject<number>(0);
    private notificationsEventsSubject = new Subject<{ opportunity: Opportunity, eventType: OpportunityEventType }>();

    private $http: IHttpService;
    private $q: IQService;

    constructor($http: IHttpService, $q: IQService) {
        this.$http = $http;
        this.$q = $q;
    }

    updateNumberOfNotifications = (n: number) => this.notificationsNumberSubject.next(n);

    getNumberOfNotificationsObservable = (): Observable<number> => this.notificationsNumberSubject.asObservable();

    getNumberOfNotifications = (): IHttpPromise<number> =>
        this.$http({method: 'GET', url: getAbsoluteUrl('api/notifications/count')});

    //TODO MOVE
    getNotifications = (page, pageSize = 20): IHttpPromise<Page<Notification>> => {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl('api/notifications', {
                page: page,
                pageSize: pageSize
            })
        });
    };

    getLqbExecutionsResultsForCalculation = (calculationId): IHttpPromise<CalculationNotificationQuickPriceResult[]> =>
        this.$http({
            method: 'GET',
            url: getAbsoluteUrl(`api/calculations/executions/${calculationId}/lqb_results`)
        });

    getNotificationsPage = (page, pageSize = 20, canceler: IDeferred<any>, filterValue?: OpportunityFilterUi): IHttpPromise<Page<Opportunity>> => {
        return this.$http({
            method: 'POST',
            data: filterValue,
            timeout: canceler.promise,
            url: getAbsoluteUrl('api/opportunity/filtered', {
                page: page,
                pageSize: pageSize
            })
        });
    };

    updateSelectedProduct = (product: CalculationNotificationQuickPriceResult) =>
        this.$http({
            method: 'PUT',
            url: getAbsoluteUrl(`api/calculations/executions/${product.calculationExecutionId}/lqb_results`),
            params: {
                change_rate_option: true,
                rate_option_id: product.id
            }
        });


    getCustomerOpportunities = (customerId: number): IHttpPromise<Opportunity[]> => this.$http({
        method: 'GET',
        url: getAbsoluteUrl(`api/opportunity/customer/${customerId}`),
    });

    getCustomerOpportunitiesSubject = (customerId: number): BehaviorSubject<Opportunity[]> => {
        let s = new BehaviorSubject<Opportunity[]>([]);
        let prom = this.getCustomerOpportunities(customerId);
        prom.then(resp => resp.status === 200 && s.next(resp.data));
        return s;
    };

    markAsFailed = (opportunityId: number) => this.$http({
        method: 'DELETE',
        url: (getAbsoluteUrl(`api/opportunity/${opportunityId}`))
    });

    markAllAsFailed = () => this.$http({
        method: 'PUT',
        url: (getAbsoluteUrl(`api/calculations/execution/all`)),
        params: {is_failed: true}
    });

    updateNotification = (notificationId: number, notification: Opportunity) => this.$http({
        method: 'PUT',
        data: notification,
        url: (getAbsoluteUrl(`api/calculations/execution/${notificationId}`))
    });

    opportunityRemoved = (opportunity: Opportunity) => this.notificationsEventsSubject.next({
        opportunity: opportunity,
        eventType: OpportunityEventType.REMOVED
    });

    subscribeForOpportunityEvents = () => this.notificationsEventsSubject.
    asObservable()
}